import React, { useContext } from 'react'
import { IntercomIsotype } from 'marketing-site/src/library/elements/IntercomIsotype'
import { IntercomIsologo } from 'marketing-site/src/library/elements/IntercomIsologo'
import CurrentLocaleContext from 'marketing-site/src/components/context/CurrentLocaleContext'

export interface IProps {
  contentType: 'flex' | 'grid'
  theme: 'light' | 'dark' | 'resolution-bot'
  isClickable: boolean
  isoOnly: boolean
}

export function HeaderLogo({
  contentType = 'flex',
  theme = 'light',
  isClickable,
  isoOnly,
}: IProps): React.ReactElement {
  const renderLogo = () =>
    isoOnly ? (
      <IntercomIsotype contentType={contentType} theme={theme} />
    ) : (
      <IntercomIsologo contentType={contentType} theme={theme} />
    )
  const { code: currentLocalCode = '', default: isDefaultCode = false } =
    useContext(CurrentLocaleContext)

  const href = isDefaultCode ? '/' : `/${currentLocalCode}`

  return (
    <>
      <span data-testid="header-logo">
        {isClickable ? (
          <a href={href} className="logo-link" aria-label="Intercom Home">
            {renderLogo()}
          </a>
        ) : (
          renderLogo()
        )}
      </span>

      <style jsx>
        {`
          .logo-link {
            display: block;
            @include focusable($inlineOffset: -8px, $blockOffset: -10px);

            &:focus {
              outline: 0;
            }
          }
        `}
      </style>
    </>
  )
}
